import { Plus } from "lucide-react";
import { Reveal, Overline } from "@/components/landing/primitives";

export function FaqSection({ items, dark = false, title = "Domande frequenti" }) {
  if (!items || !items.length) return null;
  return (
    <section data-testid="faq-section" className={`py-20 md:py-28 ${dark ? "bg-graphite text-canvas" : "bg-canvas text-ink"}`}>
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <Reveal><Overline className={dark ? "text-canvas/70" : ""}>{title}</Overline></Reveal>
        <div className="mt-10 border-t border-current/15">
          {items.map((f, i) => (
            <Reveal key={i} delay={(i % 4) * 0.05}>
              <details data-testid={`faq-item-${i}`} className="group border-b border-current/15">
                <summary className="flex items-start justify-between gap-6 cursor-pointer list-none py-6 select-none">
                  <span className="font-serif text-xl md:text-2xl leading-snug">{f.q}</span>
                  <Plus className="w-5 h-5 mt-1 shrink-0 opacity-50 transition-transform duration-300 group-open:rotate-45" />
                </summary>
                <p className={`pb-6 -mt-1 text-[15px] leading-relaxed max-w-3xl ${dark ? "text-canvas/60" : "text-muted"}`}>{f.a}</p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
